module.exports = __webpack_public_path__ + "img/2.9d3aa5a8.svg";